import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spin } from "antd";
import moment from "moment";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { getAccountingYearsTasks } from "../../../store/actions/accountingYears";
import VaporDrawer from "../../general/vapor/drawer";
// import EmptyState from "../../vapor/emptyState";
import VaporFullscreenOverlay from "../../vapor/fullscreenOverlay";
import RiscontiModal from "../fullScreenModals/riscontiModal";
import DrawerDestina from "./drawerDestina";
import DepreciationModal from "../fullScreenModals/depreciationModal";

const DrawerOperationsList = ({accountingPeriodId, selectedSequenceNumber, setDrawerAccountingPeriodId, startDate, endDate}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const [fullScreenRiscontiModal, setFullScreenRiscontiModal] = useState(false);
  const [fullScreenDepreciationModal, setFullScreenDepreciationModal] = useState(false);
  const [drawerOpeningNetIncome, setDrawerOpeningNetIncome] = useState(false);
  const [tasksList, setTasksList] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
    
  useEffect(() => {
    setIsLoadingContent(true);
    setTasksList(null);
    dispatch(getAccountingYearsTasks(accountingPeriodId)).then((res) => {
      // TODO Recuperare lista operazioni.      
      setTasksList(res?.data?.tasks);      
    }).catch((err) => {
      console.log(err);
    });    
  }, [accountingPeriodId]);

  useEffect(() => {    
    if (!tasksList) return;
    setIsLoadingContent(false);
  }, [tasksList]);
 
  const renderTaskItem = (
    isCompleted, date, title, description, openModalFunc
  ) => {
    return (
      <div style={{display: "flex", alignItems: "center", gap: "24px", marginBottom: "16px"}}>
        <div>
          <FontAwesomeIcon  icon={["far", "check-circle"]} style={{color: isCompleted ? "#005075" : "#c9d9e8"}} />
        </div>
        <div style={{display: "flex", flexDirection: "column", flex: "1 0 auto", lineHeight: "20px"}}>
          {date && <div style={{color: "#9da6ad", fontSize: "12px"}}>{moment(date).format(DATE_FORMAT_FOR_DISPLAY) }</div>}
          <div  style={{color: "#152935", fontSize: "14px", fontWeight: "bold"}}>{title}</div>
          <div>{description}</div>
        </div>
        {
        /** Se manca la funzione allora non visualizzo neppure la freccia */
          openModalFunc && 
        <div onClick={openModalFunc}>
          <FontAwesomeIcon style={{color: "#0090d1", cursor: "pointer"}} icon={["far", "arrow-right"]} /> 
        </div>
        }
      </div>
    );
  };

  return (
    <>
      <VaporDrawer    
        visible={accountingPeriodId ? true : false}
        onClose={() => setDrawerAccountingPeriodId(null)}
        title={`${intl.formatMessage({id: "accountingYear.drawer.title"})} ${selectedSequenceNumber}`}
        content={<div></div>}      
        width={"44%"}
        hideFooter={true}
        closeOnRight={true}
        customClassName="drawerOperationList"
      >
        {isLoadingContent &&
      <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
        <Spin
          indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
          size={"large"}
          tip={""}
          style={{ fontSize: "25px" }}
        />
      </div>
        }
        {
          !isLoadingContent && accountingPeriodId &&
      <div style={{padding: "32px 80px 32px 42px"}}>
        {
          /** Saldo risultato esercizio precedente. 
           * DOP-792 Se il saldo è diverso da 0 appare cta 
          */
          renderTaskItem(
            tasksList?.find(el=> el.taskId === "OPENING_NET_INCOME")?.state === "COMPLETED", 
            tasksList?.find(el=> el.taskId === "OPENING_NET_INCOME")?.date, 
            intl.formatMessage({
              id: "accountingYear.previousBalance"
            }), <div style={{display: "flex", justifyContent: "space-between"}}>
              <div><FormattedMessage id="accountingYear.drawer.total" /> &nbsp; {numeral(tasksList.find(el=> el.taskId === "OPENING_NET_INCOME")?.amount?.["EUR"] || 0).format("0,0.00")} € </div>               
            </div>,
            tasksList.find(el=> el.taskId === "OPENING_NET_INCOME")?.amount?.["EUR"] && tasksList.find(el=> el.taskId === "OPENING_NET_INCOME")?.amount?.["EUR"] !==0 ?
              () => {              
                setDrawerOpeningNetIncome(true);
              }
              : null
          )
        }
        {   /** La risposta del BE non permette una gestione agnostica */
            
          renderTaskItem(
            tasksList.find(el=> el.taskId === "DEFERRED_EXPENSES")?.state === "COMPLETED" && tasksList.find(el=> el.taskId === "DEFERRED_REVENUES")?.state === "COMPLETED",
            tasksList.find(el=> el.taskId === "DEFERRED_EXPENSES")?.date, intl.formatMessage({
              id: "accountingYear.deferrals"
            }), <div style={{display: "flex", justifyContent: "space-between"}}>
              <div><FormattedMessage id="accountingYear.drawer.totalPrepaidExpenses" /> &nbsp; {numeral(tasksList.find(el=> el.taskId === "DEFERRED_EXPENSES")?.amount?.["EUR"] || 0).format("0,0.00")} € </div> 
              <div> <FormattedMessage id="accountingYear.drawer.totalDeferredIncome" /> &nbsp;
                {numeral(tasksList.find(el=> el.taskId === "DEFERRED_REVENUES")?.amount?.["EUR"] || 0).format("0,0.00")} €</div>
            </div>,
            () => {              
              setFullScreenRiscontiModal(true);
            }
          )
        }
        {   /** La risposta del BE non permette una gestione agnostica */
            
          renderTaskItem(
            true,
            tasksList.find(el=> el.taskId === "AMMORTAMENTI_TODO")?.date, 
            "Ammortamenti",
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div> tot. Ammortamenti &nbsp; 0,00 € </div> 
            </div>,
            () => {              
              setFullScreenDepreciationModal(true);
            }
          )
        }
      </div>
        }
        {
          /*
          !isLoadingContent && tasksList?.length === 0 &&
      <EmptyState withIcon={true}
        title="Nessuna operazione " 
        description={"Per l'esercizio contabile selezionato"} 
      />
      */
        }
        
      </VaporDrawer> 
      {/** Drawer destina utile */}
      <DrawerDestina  drawerOpeningNetIncome={drawerOpeningNetIncome} 
        setDrawerOpeningNetIncome={setDrawerOpeningNetIncome} 
        amount={tasksList?.find(el=> el.taskId === "OPENING_NET_INCOME")?.amount?.["EUR"] || 0} />
      {fullScreenRiscontiModal &&
        <VaporFullscreenOverlay
          title={intl.formatMessage({id: "accountingYear.drawer.deposits"})}
          onClose={() => {            
            setFullScreenRiscontiModal(false);
          }
          }
          width={"100vw"}
          simulatePage
        >
          <RiscontiModal accountingPeriodId={accountingPeriodId}/>
        </VaporFullscreenOverlay>
      }
      {fullScreenDepreciationModal &&
        <VaporFullscreenOverlay
          title={intl.formatMessage({id: "accountingYear.drawer.depreciation"})}
          onClose={() => {            
            setFullScreenDepreciationModal(false);
          }
          }
          width={"100vw"}
          simulatePage
        >
          <DepreciationModal 
            selectedSequenceNumber={selectedSequenceNumber}
            startDate={startDate}
            endDate={endDate}
          />
        </VaporFullscreenOverlay>
      }
    </>
  );
};

export default DrawerOperationsList;